import React from 'react';

import APIClient from './APIClient';
import Alert from './Alert';

import './Form.css';

class RegisterForm extends React.Component {
  emailField = React.createRef();
  passwordField = React.createRef();
  passwordConfirmField = React.createRef();

  state = {
    error: null,
    registered: false,
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.setState({ error: null });

    const email = this.emailField.current.value;
    const password = this.passwordField.current.value;
    const passwordConfirm = this.passwordConfirmField.current.value;

    APIClient.shared.register(email, password, passwordConfirm)
      .then(() => {
        this.setState({ registered: true })
      })
      .catch(error => {
        this.setState({ error });
        console.error(error);
      });
  };

  render() {
    return (
      <div className="RegisterForm">
        {this.state.error && <Alert title="Error" message={this.state.error.message} />}
        {!this.state.registered &&
          <form className="Form" onSubmit={this.handleSubmit}>
            <div className="Form__group">
              <label htmlFor="email">Email address</label>
              <input id="email" type="email" ref={this.emailField}/>
            </div>

            <div className="Form__group">
              <label htmlFor="password">Password</label>
              <input id="password" type="password" ref={this.passwordField}/>
            </div>

            <div className="Form__group">
              <label htmlFor="passwordConfirm">Confirm password</label>
              <input id="passwordConfirm" type="password" ref={this.passwordConfirmField}/>
            </div>

            <button type="submit">Register</button>
          </form>
        }
        {this.state.registered &&
          <Alert title="Confirm email address" message="Check your email for a confirmation link." />
        }
      </div>
    );
  }
}

export default RegisterForm;



// WEBPACK FOOTER //
// ./src/RegisterForm.js